// extracted by mini-css-extract-plugin
export var layoutContainer = "_dk-0";
export var layoutContainerNoRounding = "_dk-6";
export var layoutContainerOpen = "_dk-5";
export var layoutContainerResizing = "_dk-1";
export var mainContent = "_dk-2";
export var resizeDivider = "_dk-3";
export var slidePanel = "_dk-4";